import { sel, selAll, stLineWrap } from './utils'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

export default function Author() {
  const ctx = gsap.context(() => {
    // const heroHSplit = new SplitText('.hero__h', { types: 'lines, words', mask: 'lines' })
    const heroHSplit = new SplitText('.hero__h', { types: 'lines, words', linesClass: 'st-line' })
    const heroSSplit = new SplitText('.case-header__info .text-style-tagline', { types: 'lines, words', linesClass: 'st-line' })
    const heroPSplit = new SplitText('.case-header__info .subtitle', { types: 'lines, words', mask: 'lines' })
    const img$ = sel('.person__img-w')
    const heroTl = gsap.timeline({ defaults: { ease: 'power4.out' } })
    heroTl
      .from(heroHSplit.words, { y: '100%', duration: 1.5, stagger: 0.15 }, 0)
      .from(heroSSplit.words, { y: '100%', duration: 1.5, stagger: 0.1 }, '>-1.5')
      .from(heroPSplit.words, { y: '100%', duration: 1.5, stagger: 0.05 }, '>-1.5')
      .from(img$, { y: 50, opacity: 0, duration: 1.5 }, '>-1.5')

    const bioRt$ = sel('.person__rt')

    if (bioRt$) {
      // Split text into words
      const bioSplit = new SplitText(bioRt$, { type: 'words', wordsClass: 'word' })

      // Set initial state - all words gray
      // gsap.set(split.words, { color: 'var(--color--gray-3)' })
      gsap.set(bioSplit.words, { color: 'var(--color--ceiling)' })

      // Create ScrollTrigger animation
      gsap.to(bioSplit.words, {
        autoAlpha: 1,
        color: 'var(--color--floor)',
        duration: 1,
        ease: 'power4.out',
        stagger: 0.01,
        scrollTrigger: {
          trigger: bioRt$,
          start: 'top 80%',
          end: 'bottom 20%',
          scrub: false,
          once: true,
        },
      })
    }
  })
  return ctx
}
